import type { PredictionContract } from '@/services/prediction/types'

/**
 * Port of cdc-web `src/utils/contractLabels.ts` —— TwoWayCard 只需要
 * `getContractFullName`（OutcomRow 名称 + badge initials 回退名）。
 * `getContractAbbrev` / `getMarketLabels` / `getContractPrimaryLabel` 等
 * spread/total 与列表页专用函数不抄。
 */

/**
 * Canonical "full name" for a contract — the long, human-readable string.
 *
 * Priority (mirrors og-app; see OG-5366):
 *   1. `individual_profile.first_name + last_name` (player-based events)
 *   2. `contract.contract_title` (BE-composed outcome text, e.g.
 *      "San Antonio wins 4-3")
 *   3. `team.display_name` (plain team label, kept as fallback so
 *      "Lakers" / "Celtics" still render when BE omits a contract_title)
 *   4. `fallbackFromTitle` (caller-provided, e.g. from `parseMatchEventTitle`)
 *   5. `''`
 */
export function getContractFullName(contract?: PredictionContract, fallbackFromTitle = ''): string {
  if (contract?.individual_profile?.first_name && contract?.individual_profile?.last_name) {
    return `${contract.individual_profile.first_name} ${contract.individual_profile.last_name}`
  }
  return contract?.contract_title || contract?.team?.display_name || fallbackFromTitle || ''
}
